import React, { useState, useEffect } from "react";

const PropositoComponent: React.FC = () => {
  const slides = [
    { description: "Nuestro propósito", title: "Conectar a las personas con tiempo de calidad" },
    { description: "Visión", title: "Progreso para la humanidad" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState("enter");

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection("exit");
      setTimeout(() => {
        setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
        setDirection("enter");
      }, 1000);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="nuestro-proposito">
      {/* H3 - Descripción (Nuestro propósito / Visión) */}
      <h3 className={`description ${direction}`}>
        {slides[currentSlide].description}
      </h3>
      
      {/* H2 - Título principal (Conectar a las personas... / Progreso para la humanidad) */}
      <h2 className={`title ${direction}`}>
        {slides[currentSlide].title}
      </h2>
    </div>
  );
};

export default PropositoComponent;